import { combineEpics } from 'redux-observable';
import { MessageSettingsActionTypes, FetchMessageSettings, UpdateMessageSettings, ClearMessageSettings } from '../actions/MessageSettingsActions';
import { getFetchMessageSettingsRequestStatus, getUpdateMessageSettingsRequestStatus, getClearMessageSettingsRequestStatus } from '../selectors/RequestStatusSelector';
import MessageSettingsAPI from '../api/MessageSettingsAPI';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import requestEntity from './requestEntity';
import RequestEpicDescriptor from './RequestEpicDescriptor';
const fetchMessageSettings = requestEntity(new RequestEpicDescriptor({
  apiFunction: MessageSettingsAPI.getMessageSettings,
  initiatingActionType: MessageSettingsActionTypes.LOAD_MESSAGE_SETTINGS,
  requestStatusSelector: getFetchMessageSettingsRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: FetchMessageSettings
}));
const setMessageSettings = requestEntity(new RequestEpicDescriptor({
  apiFunction: MessageSettingsAPI.updateMessageSettings,
  initiatingActionType: MessageSettingsActionTypes.UPDATE_MESSAGE_SETTINGS,
  requestStatusSelector: getUpdateMessageSettingsRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: UpdateMessageSettings
}));
const clearMessageSettings = requestEntity(new RequestEpicDescriptor({
  apiFunction: MessageSettingsAPI.updateMessageSettings,
  initiatingActionType: MessageSettingsActionTypes.CLEAR_MESSAGE_SETTINGS,
  requestStatusSelector: getClearMessageSettingsRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: ClearMessageSettings
}));
export default combineEpics(fetchMessageSettings, setMessageSettings, clearMessageSettings);